import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import DJs from "@/pages/DJs";
import DJProfile from "@/pages/DJProfile";
import ChatPage from "@/pages/Chat";
import AdminPage from "@/pages/Admin";
import AboutPage from "@/pages/About";
import DirectoryPage from "@/pages/Directory";
import PartnersPage from "@/pages/Partners";
import SchedulePage from "@/pages/Schedule";
import SubmitPage from "@/pages/Submit";
import Family from "@/pages/Family";
import SubmitGig from "@/pages/SubmitGig";
import EmbedPage from "@/pages/Embed";
import WidgetPage from "@/pages/Widget";
import Archive from "@/pages/Archive";
import PersistentPlayerBar from "@/components/PersistentPlayerBar";
import { useEffect } from "react";
import { trackVisit } from "@/lib/visitorSession";

function App() {
  // Every arrival, on any page, new or returning, lights up the globe.
  useEffect(() => {
    trackVisit().catch(() => {});
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/djs" element={<DJs />} />
          <Route path="/djs/:slug" element={<DJProfile />} />
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/directory" element={<DirectoryPage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/schedule" element={<SchedulePage />} />
          <Route path="/submit" element={<SubmitPage />} />
          <Route path="/family" element={<Family />} />
          <Route path="/submit-gig" element={<SubmitGig />} />
          <Route path="/widget" element={<WidgetPage />} />
          <Route path="/embed" element={<EmbedPage />} />
          <Route path="/archive" element={<Archive />} />
        </Routes>
        <PersistentPlayerBar />
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#18181b",
            border: "1px solid #3f3f46",
            color: "#fafafa",
            borderRadius: 0,
            fontFamily: "IBM Plex Mono, monospace",
          },
        }}
      />
    </div>
  );
}

export default App;
